export class BaseIndicatorModel {
  protected states: Map<string, string>;
  protected defaultIcon: string;

  getIconSource(status: string): string {
    return this.states.has(status) ? this.states.get(status) : this.defaultIcon;
  }
}
